export const GET_ASSESSMENT_LEVEL_LIST = '/land/get_assessment_level_list';
export const GET_SINGLE_ASSESSMENT_LEVEL = '/land/get_single_land_class';
export const CREATE_ASSESSMENT_LEVEL = '/land/create_land_classifications';
export const UPDATE_ASSESSMENT_LEVEL = '/land/update_land_classifications';
export const REMOVE_ASSESSMENT_LEVEL =
  '/land/remove_transaction_code_land_classifications';
export const GET_LAND_CLASSIFICATIONS_LIST = '/land/get_land_classifications';

export const GET_ORDINANCE_REVISION = '/settings/get_ordinance_revision_list';

export const FORM_DATA = {
  rptax_land_classification_id: '',
  assessment_level: '',
  ordinance_revision_id: '',
};
